import { useKeycloak } from "@react-keycloak/web";
import { useEffect } from "react";
import { Navigate, Route, Routes } from 'react-router-dom';
import Layout from "../layout/layout";
import HomePage from "./home/home.page";
import { oblast } from "../consts/kato.conts";
import IndicatorsPage from "./indicators/indicators.page";
import AdminPage from "./admin/admin.page";
import KatoList from "./admin/pages/kato-list/kato-list.page";
import EditItemPage from "./edit-item/edit-item.page";
import { getLastVisitDate, recordVisit } from "../requests/visit";
import StatsPage from "./stats/stats.page";

const RoutesIndex = () => {
    const { initialized, keycloak } = useKeycloak();

    useEffect(() => {
        if (!keycloak || !initialized) return;

        keycloak.onTokenExpired = () => keycloak.updateToken(600);

        if (!keycloak.authenticated) {
            keycloak.login();
            return;
        }

        const formatDate = (d: Date) => d.toISOString().split('T')[0]; // YYYY-MM-DD
        const currentDate = formatDate(new Date());
        const localDate = localStorage.getItem('DP_LAST_VISIT_DATE');

        const updateVisit = () => {
            recordVisit().then(() => {
                localStorage.setItem('DP_LAST_VISIT_DATE', currentDate);
            });
        };

        if (localDate) {
            if (localDate !== currentDate) {
                updateVisit();
            }
        } else {
            getLastVisitDate().then((serverDate: any) => {
                if (!serverDate) {
                    updateVisit();
                    return;
                }
                localStorage.setItem('DP_LAST_VISIT_DATE', serverDate);
                if (serverDate !== currentDate) {
                    updateVisit();
                }
            });
        }
    }, [initialized, keycloak]);


    return (
        initialized ? <Routes>
            <Route path='/' element={<Layout />}>
                <Route index element={<Navigate to={`/${oblast.kato}`} replace />} />
                <Route path=":kato/" element={<HomePage />} />
                <Route path=":kato/:link" element={<HomePage />} />
                <Route path=":kato/:link/:tab" element={<HomePage />} />
                <Route path=":kato/:link/:tab/:type" element={<HomePage />} />
            </Route>
            <Route path="/admin" element={<AdminPage />}>
                <Route index element={<Navigate to={`/admin/kato-list`} replace />} />
                <Route path="kato-list" element={<KatoList />} />
                <Route path=":kato" element={<EditItemPage />} />
                <Route path=":kato/:link" element={<EditItemPage />} />
                <Route path=":kato/:link/:tab" element={<EditItemPage />} />
                <Route path=":kato/:link/:tab/:id" element={<EditItemPage />} />
            </Route>
            <Route path="/stats" element={<StatsPage />} />

        </Routes> : null
    )
}

export default RoutesIndex;